import '../scss/main.scss';
import './react/agenda';

import Nav from './components/Nav';
import Accordion from './components/Accordion';
import IsDraggable from './components/IsDraggable';
import HideOnScroll from './components/HideOnScroll';
import VideoPlayer from './components/VideoPlayer';
import TicketBar from './components/TicketBar';
import Newsletter from './components/Newsletter';
import Glide from '@glidejs/glide';
import CountdownButton from './components/CountdownButton';
import Favourites from './components/Favourites';
import Login from './login/login.js';
import Logout from './logout/logout.js';
import Tixly from './tixly/tixly.js';

import './vriendenverkoop/vriendenverkoop.js';
import './wishlist/wishlist.js';

document.querySelectorAll('.js-glide').forEach((el) => {
	new Glide(el, {type: 'carousel'}).mount();
 });

document.querySelectorAll('.js-nav').forEach((el) => {
  new Nav(el);
});

document.querySelectorAll('.js-ticket-bar').forEach((el) => {
	new TicketBar(el);
 });

document.querySelectorAll('.js-accordion').forEach((el) => {
  new Accordion(el);
});

document.querySelectorAll('.js-is-draggable').forEach((el) => {
  new IsDraggable(el);
});

document.querySelectorAll('.js-hide-on-scroll').forEach((el) => {
  new HideOnScroll(el);
});

document.querySelectorAll('.js-video-player').forEach((el) => {
	new VideoPlayer(el);
});

document.querySelectorAll('.js-newsletter-subscribe').forEach((el) => {
	new Newsletter(el);
});

if ( ! customData?.friendSaleTicketInfo ) {
	document.querySelectorAll('.js-ticket-info').forEach((el) => {
		el.style.display = 'none'; // is friend so banner not required
	})
}

document.querySelectorAll('body.single-event,body.mge-wishlist').forEach((el) => {
	let url = location.protocol + '//' + location.host + location.pathname;
	if ( 'undefined' != typeof url ) {
		localStorage.setItem( 'last_event_page', url );
	}
});

document.querySelectorAll('.js-ticket-info[hidden]').forEach((el) => {
	const parseTimestamp = (timestamp, offset) => Math.floor(parseInt(timestamp) + parseInt(offset));
	let tz = el.dataset.timezoneoffsetserver;
	let showStart = parseTimestamp( el.dataset.showtimestamp, tz );
	let showUntil = parseTimestamp( el.dataset.hidetimestamp, tz );
	let now = Math.floor(Date.now() / 1000);
	if (showStart <= now && showUntil > now) {
		el.removeAttribute('hidden'); // is friend so banner not required
	}

	el.querySelectorAll('p[hidden]').forEach((p) => {
		let showFrom = parseTimestamp( p.dataset.showtimestamp, tz );
		if (showFrom <= now) {
			p.classList.add('active');
		}
	});

	let allActiveElems = el.querySelectorAll('p[hidden].active');
	if ( allActiveElems.length > 0 ) {
		allActiveElems[ allActiveElems.length - 1 ].classList.add('last');
	}
});

document.querySelectorAll('.js-favourites').forEach((el) => {
	new Favourites(el);
});

const account_nav = document.querySelector('#tm_account');
if (account_nav) {
	let ls_account = 'tm_account_continue';
	localStorage.removeItem( ls_account );
	account_nav.addEventListener('click', (e) => {
		localStorage.setItem( ls_account, 1 );
	});
}

document.querySelectorAll('body.tm-login').forEach((el) => {
	const args = new URLSearchParams(window.location.search);
	new Login(args);
});

document.querySelectorAll('body.tm-logging-out').forEach((el) => {
	const args = new URLSearchParams(window.location.search);
	new Logout(args);
});

document.querySelectorAll('.js-btn-countdown').forEach((el) => {
	new CountdownButton(el);
});

if (document.querySelector('.mge-user__toggle')) {
	new Tixly();
}

document.addEventListener('DOMContentLoaded', function () {
	//not sure if more than one iframe on a page will be used, but just in case
	document.querySelectorAll('.deploytec-iframe').forEach((el) => {
		const urlParams = new URLSearchParams(window.location.search);
		const clangUrl = urlParams.get('Clang_url');
		const emailHash = urlParams.get('email_hash');

		if (clangUrl) {
			let iframeSrc = new URL(clangUrl);
			// Append the email_hash parameter if it exists
			if (emailHash) {
				iframeSrc.searchParams.set('email_hash', emailHash);
			}
			// replace iframe src with Clang_url (used in newsletter footer to adjust preferences)
			el.src = iframeSrc.toString();
		}
	});
});
